<template>
  <div class="results-collected">
    <div class="header-title">成绩收集</div>
    <div v-if="studentName">
      <div class="main-content">
        <div class="title">
          <span>家长您好，为了更好的了解孩子的情况，烦请您填写成绩收集表：</span>
        </div>
        <div class="item name">
          学生姓名：{{ studentName }}（{{ studentCode }}）
        </div>
        <div class="item">成绩类型：{{ paperName }}考试成绩</div>
        <div class="item name">年级：{{ gradeName }}</div>
        <div v-for="item in subjectResultsList" :key="item.taskId">
          <div class="item">
            <span>科目：</span>
            <span>{{ item.subjectName }}</span>
          </div>
          <div class="item other">
            <span>班级排名：</span>
            <input
              class="item-input"
              style="width: 80px"
              type="number"
              placeholder="输入排名"
              v-model="item.classRank"
            />
            <div class="slash"></div>
            <input
              class="item-input"
              style="width: 110px; margin-left: 30px"
              type="number"
              placeholder="输入总人数"
              v-model="item.classCount"
            />
          </div>
          <div class="item other">
            <span>年级排名：</span>
            <input
              class="item-input"
              style="width: 80px"
              type="number"
              placeholder="输入排名"
              v-model="item.schoolRank"
            />
            <div class="slash"></div>
            <input
              class="item-input"
              style="width: 110px; margin-left: 30px"
              type="number"
              placeholder="输入总人数"
              v-model="item.schoolCount"
            />
          </div>
        </div>
      </div>
      <div class="button-box">
        <van-button
          :loading="isLoading"
          class="button"
          square
          block
          type="info"
          native-type="submit"
          @click="submit"
          >提交</van-button
        >
      </div>
  </div>
  <div v-else>
    <van-empty description="暂无成绩收集数据" />
  </div>
  </div>
</template>
<script>
export default {
  name: "resultsCollect",
  data() {
    return {
      isLoading: false,
      studentName: "",
      studentId: "",
      studentCode: "",
      paperName: "",
      paperType: "",
      subjectResultsList: [],
      paperTerm: "",
      studentInfo: {},
      paperYearTerm: "",
      cityCode: "",
      gradeName: "",
      teacherId: "",
      teachName: "",
    };
  },
  created() {
    this.searchList(this.$route.query.taskId);
  },
  methods: {
    // 家长查询需要录入的成绩列表
    searchList(taskId) {
      this.$api.resultsCollect
        .collectStudentBySubject({ taskId })
        .then((res) => {
          if (res.ret) {
            this.studentInfo = res.data;
            this.studentName = res.data.studentName; // 学生姓名
            this.studentId = res.data.studentId; // 学生ID
            this.studentCode = res.data.studentCode; // 学生编码
            this.paperName = res.data.paperName; // 成绩类型名称
            this.paperType = res.data.paperType;
            this.paperTerm = res.data.term;
            this.paperYearTerm = res.data.termYear;
            this.cityCode = res.data.cityCode;
            this.gradeName =
              res.data.scoreList && res.data.scoreList[0].gradeName;
            this.teacherId =
              res.data.scoreList && res.data.scoreList[0].teacherId;
            this.teacherName =
              res.data.scoreList && res.data.scoreList[0].teacherName;
            this.subjectResultsList =
              res.data.scoreList &&
              res.data.scoreList.map((item) => {
                return {
                  ...item,
                  classRank: "",
                  classCount: "",
                  schoolRank: "",
                  schoolCount: "",
                };
              }); // 需要收集的成绩列表
          }
        });
    },
    // 家长成绩录入提交
    submit() {
      // 验证填写的数据是否符合要求
      let isPass = true,
        _this = this;
      this.subjectResultsList.forEach((item) => {
        // 班级或年级的数据不全
        let noData = !(
          (item.classRank && item.classCount) ||
          (item.schoolRank && item.schoolCount)
        );
        // 班级数据大小有问题
        let classErr = Number(item.classRank) > Number(item.classCount);
        // 年级数据大小有问题
        let schoolErr = Number(item.schoolRank) > Number(item.schoolCount);
        // 班级人数有，名次不能为0
        let classRankErr =
          Number(item.classCount) > 0 && Number(item.classRank) == 0;
        // 班级人数有，名次不能为0
        let schoolRankErr =
          Number(item.schoolCount) > 0 && Number(item.schoolRank) == 0;

        noData &&
          formatErr(
            `请填写科目 ${item.subjectName} 的班级或年级的排名和总人数`
          );
        classErr &&
          formatErr(
            `科目 ${item.subjectName} 您填写的班级名次大于班级总人数，请确认后再填`
          );
        schoolErr &&
          formatErr(
            `科目 ${item.subjectName} 您填写的年级名次大于年级总人数，请确认后再填`
          );
        classRankErr &&
          formatErr(
            `科目 ${item.subjectName} 的班级总人数已填写，所以名次不能为0`
          );
        schoolRankErr &&
          formatErr(
            `科目 ${item.subjectName} 的年级总人数已填写，所以名次不能为0`
          );

        function formatErr(msg) {
          _this.$toast(`${msg}`);
          isPass = false;
        }
      });
      if (!isPass) return;

      this.$api.resultsCollect
        .submitByParentScore({
          studentName: this.studentName,
          studentId: this.studentId,
          paperType: this.paperType,
          paperName: this.paperName,
          paperTerm: this.paperTerm,
          paperYearTerm: this.paperYearTerm,
          cityCode: this.cityCode,
          teacherId: this.teacherId,
          teacherName: this.teacherName,
          scoreList: this.subjectResultsList.map((item) => {
            item.classCount = Number(item.classCount);
            item.classRank = Number(item.classRank);
            item.schoolCount = Number(item.schoolCount);
            item.schoolRank = Number(item.schoolRank);
            return item;
          }),
        })
        .then((res) => {
          res.ret ? this.$toast(`提交成功`) : this.$toast(res.msg);
        });
    },
  },
};
</script>

<style scoped lang="scss">
.results-collected {
  height: 100%;
  .header-title {
    padding: 15px 0;
    font-weight: 600;
    text-align: center;
    font-size: 20px;
    color: #fff;
    background: #3aa7ef;
  }
  .main-content {
    padding: 15px;
    .title {
      color: #646566;
    }
    .name {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .item {
      margin: 10px 0;
      padding: 5px 0;
      width: 100%;
      color: #646566;
      border-bottom: 1px solid #f5f6f7;
      .item-input {
        border: 1px solid #f5f6f7;
        padding: 5px;
        appearance: textfield;
      }
      .slash {
        width: 1px;
        height: 30px;
        background: #c4c4c4;
        display: inline-block;
        position: relative;
        left: 15px;
        top: 10px;
        transform: rotate(20deg);
      }
    }
    .other {
      margin-top: -10px;
    }
  }
  .button-box {
    width: 100%;
    margin-top: 30px;
    display: flex;
    justify-content: center;
    .button {
      width: 250px;
      border-radius: 8px;
    }
  }
}
</style>
